import apiFetch from "../../../../shared/services/apiClient";

/**
 * Envía el correo de uno o varios recibos.
 * Solo los recibos con facturas aplicadas serán enviados.
 * Los que no tienen facturas aparecen en `sin_facturas`.
 *
 * @param {number[]} reciboIds
 * @param {'es'|'en'} idioma    - idioma del PDF y correo (default 'es')
 * @returns {{ enviados, errores, sin_facturas, total_enviados, total_errores }}
 */
export async function sendReceiptEmail(reciboIds, idioma = 'es') {
  const res = await apiFetch("/api/finance/recibo/enviar-email/", {
    method: "POST",
    body: JSON.stringify({ recibo_ids: reciboIds, idioma }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error ?? "Error al enviar el correo del recibo.");
  }

  return res.json();
}
